import { render } from "./certificate-student.vue?vue&type=template&id=767f5ab0&scoped=true"
import script from "./certificate-student.vue?vue&type=script&lang=js"
export * from "./certificate-student.vue?vue&type=script&lang=js"

import "./certificate-student.vue?vue&type=style&index=0&id=767f5ab0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f5ab0"]])

export default __exports__